import React, { useState, forwardRef } from "react";
import PrimarySearchAppBar from "../../components/Navbar";
import Sidebar from "../../components/Navbar/Sidebar";
import {
  homepageMenuItems,
  homepageSideMyMenuItems,
  homepageSideMoreMenuItems,
  searchAdspageMenuItems,
  pMaxpageMenuItems,
  displayAdspageMenuItems,
  metaTravelAdspageMenuItems,
  aiConnectpageMenuItems,
} from "../../constants/productmenu";
import { Box } from "@mui/material";
import { useSelector } from "react-redux";

const DefaultLayout = forwardRef((
    {
        page,
        children,
        // Lets a page drop the product sidebar while keeping the navbar (and its
        // account dropdown). Used when there is no account to work on, since
        // every sidebar entry needs one.
        hideSidebar = false,
        mainBoxSx = {
            display: "flex",
            height: "95.5vh",
            overflow: "hidden",
        },
        contentBoxSx = {
            backgroundColor: "#FAFAFA",
            flex: 1,
            paddingTop: 2,
            width: "calc(100vw - 180px)",
            height: "100%",
            overflow: "auto",
        }
    },
    ref
) => {

  const { account_id = "" } = useSelector(
    (state) => state?.account?.account || {}
  );

  const [currentSection, setCurrentSection] = useState(useSelector((state) => state?.sidebar) ?? page);

  const menuItems = () => {
    switch(page){
      case "SearchAdsPage":
        return searchAdspageMenuItems(account_id);
      case "PMax":
        return pMaxpageMenuItems(account_id);
      case "DisplayAds":
        return displayAdspageMenuItems(account_id)
      case "MetaTravel":
        return metaTravelAdspageMenuItems(account_id)
      case "aiConnect":
        return aiConnectpageMenuItems(account_id);
      default:
        return homepageMenuItems(account_id)
    }
  }

  return (
    <>
      <PrimarySearchAppBar />

      <Box
        className="mainBox"
        sx={{
            ...mainBoxSx
        }}
      >
        {!hideSidebar && (
          <Sidebar
            page={page}
            menuItems={
              menuItems()
            }
            moreItems={homepageSideMoreMenuItems}
            initialItems={homepageSideMyMenuItems(account_id)}
            currentSection={currentSection}
            setCurrentSection={setCurrentSection}
          />
        )}
        <Box
          sx={{
              ...contentBoxSx,
              // The default width reserves room for the sidebar.
              ...(hideSidebar ? { width: "100%" } : {})
          }}
          ref={ref}
        >
          {children}
        </Box>
      </Box>
    </>
  );
});

export default DefaultLayout;